var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31445 22.5H8.14779M22.8145 6V7.83333M37.4811 22.5H39.3145M11.0811 10.7667L12.3645 12.05M34.5478 10.7667L33.2645 12.05M18.5978 31.6667H27.0311M17.3145 29.8333C15.7753 28.679 14.6384 27.0696 14.0647 25.2332C13.4911 23.3968 13.5098 21.4264 14.1182 19.6012C14.7266 17.7761 15.8938 16.1886 17.4546 15.0636C19.0154 13.9387 20.8905 13.3333 22.8145 13.3333C24.7384 13.3333 26.6135 13.9387 28.1743 15.0636C29.7351 16.1886 30.9023 17.7761 31.5107 19.6012C32.1191 21.4264 32.1378 23.3968 31.5642 25.2332C30.9905 27.0696 29.8536 28.679 28.3145 29.8333C27.5987 30.5419 27.0597 31.409 26.7412 32.3645C26.4227 33.32 26.3336 34.337 26.4811 35.3333C26.4811 36.3058 26.0948 37.2384 25.4072 37.9261C24.7195 38.6137 23.7869 39 22.8145 39C21.842 39 20.9094 38.6137 20.2217 37.9261C19.5341 37.2384 19.1478 36.3058 19.1478 35.3333C19.2953 34.337 19.2062 33.32 18.8877 32.3645C18.5692 31.409 18.0302 30.5419 17.3145 29.8333Z",
    stroke: "#192BC2",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/Bulb.ee2e0b05002b96d5cb07a076ea0ee1ba.svg";
export { ForwardRef as ReactComponent };